"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var support_1 = require("../functions/support");
var cerealParse_1 = require("../../cerealParse");
/**
 * Mixin for agency API calls.
 */
var AgencyMixin = /** @class */ (function () {
    function AgencyMixin() {
    }
    /**
     * Get an agency's dispatchers.
     * @param agencyId
     * @param callback
     */
    AgencyMixin.prototype.getDispatchers = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.FindUser.parse, "warn"));
        };
        this.http.get("/agencies/".concat(agencyId, "/dispatchers"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get an agency's SCU managers.
     * @param agencyId
     * @param callback
     */
    AgencyMixin.prototype.getSCUManagers = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.FindUser.parse, "warn"));
        };
        this.http.get("/agencies/".concat(agencyId, "/scu-managers"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get an agency's invites.
     * @param agencyId
     * @param limit
     * @param page
     * @param query
     * @param sortConfig
     * @param callback
     */
    AgencyMixin.prototype.getInvites = function (agencyId, limit, page, query, sortConfig, callback) {
        var _this = this;
        var urlParams = {
            limit: limit,
            page: page,
            sortBy: sortConfig.column,
            order: sortConfig.direction,
        };
        if (query != null) {
            urlParams.query = query;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, "invites", models_1.Invite.parse); }));
        };
        this.http.get("/agencies/".concat(agencyId, "/invites"), urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.uploadAgencyFile = function (agencyId, file, callback) {
        var _this = this;
        // TODO: This should be included in bryx-../../spoonClient but it does not support file upload currently
        var formData = new FormData();
        formData.append("file", file);
        var request = new XMLHttpRequest();
        request.onreadystatechange = function () {
            if (request.readyState == request.DONE) {
                if (request.status == 200) {
                    try {
                        callback(_this.apiSuccess(JSON.parse(request.responseText)["id"]));
                    }
                    catch (_a) {
                        callback(_this.apiFailure("Invalid response"));
                    }
                }
                else {
                    callback(_this.apiFailure("Invalid response (".concat(request.status, "): ").concat(request.responseText)));
                }
            }
        };
        request.open("POST", "".concat(this.apiRoot, "/agencies/").concat(agencyId, "/files"));
        var apiKey = this.local.apiKey;
        if (apiKey != null) {
            request.setRequestHeader("X-API-KEY", apiKey);
        }
        request.send(formData);
    };
    /**
     * Get an agency's SCUs.
     * @param agencyId
     * @param callback
     */
    AgencyMixin.prototype.getAgencySCUs = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.SCU.parse, "warn"));
        };
        this.http.get("/agencies/".concat(agencyId, "/scus"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Submit a boundary update request to Bryx Support.
     * @param from
     * @param agency
     * @param polygon
     * @param file
     * @param callback
     */
    AgencyMixin.prototype.sendBoundaryUpdateRequest = function (from, agency, polygon, file, local, callback) {
        var _this = this;
        var sendRequest = function (fileAttachment) {
            var attachments = [
                {
                    contentType: "text/plain",
                    fileName: "localStorage.txt",
                    data: (0, support_1.bryxItemsAttachment)(local),
                },
                {
                    contentType: "text/plain",
                    fileName: "logs.txt",
                    data: (0, support_1.logsAttachment)(local.log),
                },
                {
                    contentType: "text/plain",
                    fileName: "deviceInfo.txt",
                    data: (0, support_1.deviceInfoAttachment)(),
                },
            ];
            if (fileAttachment != null) {
                attachments.push(fileAttachment);
            }
            if (polygon != null) {
                attachments.push({
                    fileName: "boundary.json.txt",
                    contentType: "text/plain",
                    data: (0, support_1.jsonAttachment)(polygon),
                });
            }
            var requestBody = {
                body: "I would like to update the boundary for ".concat(agency.name, ". Please see attached."),
                email: from,
                subject: "Bryx Agency Boundary Update Request",
                type: "feedback",
                platform: "management",
                attachments: attachments,
            };
            var wrappedCallback = function (request, response) {
                callback(_this.apiResultFromParse(response, _this.nullParser));
            };
            _this.http.post("/support", null, requestBody, _this.unauthenticatedCallback(wrappedCallback));
        };
        if (file != null) {
            (0, support_1.readFileToAttachment)(file, function (result) {
                if (result.key == "success") {
                    sendRequest(result.attachment);
                }
                else {
                    callback(_this.apiFailure(null, "Unable to read file: ".concat(result.message)));
                }
            });
        }
        else {
            sendRequest(null);
        }
    };
    /**
     * Get an agency by ID
     * @param agencyId
     * @param callback
     */
    AgencyMixin.prototype.getAgency = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Agency.parse));
        };
        this.http.get("/agencies/".concat(agencyId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get an agency's streams by ID
     * @param agencyId
     * @param callback
     */
    AgencyMixin.prototype.getAgencyStreams = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.Stream.parse, "warn"));
        };
        this.http.get("/agencies/".concat(agencyId, "/streams"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create a station by agency ID
     * @param agencyId
     * @param name
     * @param address
     * @param latitude
     * @param longitude
     * @param callback
     */
    AgencyMixin.prototype.createStation = function (agencyId, name, address, latitude, longitude, callback) {
        var _this = this;
        var body = {
            name: name,
            address: address,
            latitude: latitude,
            longitude: longitude,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Station.parse));
        };
        this.http.post("/agencies/".concat(agencyId, "/stations"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit a station by agency and station ID
     * @param agencyId
     * @param stationId
     * @param name
     * @param address
     * @param latitude
     * @param longitude
     * @param callback
     */
    AgencyMixin.prototype.editStation = function (agencyId, stationId, name, address, latitude, longitude, callback) {
        var _this = this;
        var body = {
            name: name,
            address: address,
            latitude: latitude,
            longitude: longitude,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Station.parse));
        };
        this.http.put("/agencies/".concat(agencyId, "/stations/").concat(stationId), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Delete a station by ID
     * @param agencyId
     * @param stationId
     * @param callback
     */
    AgencyMixin.prototype.deleteStation = function (agencyId, stationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/".concat(agencyId, "/stations/").concat(stationId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Update settings for an agency by ID
     * @param agencyId
     * @param settings
     * @param callback
     */
    AgencyMixin.prototype.updateAgency = function (agencyId, settings, callback) {
        var _this = this;
        var body = {
            settings: settings,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/".concat(agencyId), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Gets new translations for an agency
     * @param agencyId
     * @param callback
     */
    AgencyMixin.prototype.getScuTranslations = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.ScuTranslation.parse, "throw"));
        };
        this.http.get("/agencies/".concat(agencyId, "/scu-translations"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.addTranslationToStage = function (agencyId, scuTranslationId, stage, translation, callback) {
        var _this = this;
        var wrappedCallback = function (_, response) {
            callback(_this.apiResultFromParse(response, models_1.Translation.parse));
        };
        this.http.post("/agencies/".concat(agencyId, "/scu-translations/").concat(scuTranslationId, "/stages/").concat(stage, "/translations"), null, translation.toJson(), this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.editTranslationInStage = function (agencyId, scuTranslationId, stage, translation, callback) {
        var _this = this;
        var wrappedCallback = function (_, response) {
            callback(_this.apiResultFromParse(response, models_1.Translation.parse));
        };
        this.http.put("/agencies/".concat(agencyId, "/scu-translations/").concat(scuTranslationId, "/stages/").concat(stage, "/translations/").concat(translation.id), null, translation.toJson(), this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.deleteTranslationFromStage = function (agencyId, scuTranslationId, stage, translationId, callback) {
        var _this = this;
        var wrappedCallback = function (_, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/".concat(agencyId, "/scu-translations/").concat(scuTranslationId, "/stages/").concat(stage, "/translations/").concat(translationId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.runNewTestTranslation = function (agencyId, raw, key, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) {
                try {
                    var res = {
                        raw: cerealParse_1.ParseUtils.getString(o, "raw"),
                        key: cerealParse_1.ParseUtils.getString(o, "key"),
                        translation: cerealParse_1.ParseUtils.getString(o, "translation"),
                    };
                    return cerealParse_1.ParseUtils.parseSuccess(res);
                }
                catch (e) {
                    return cerealParse_1.ParseUtils.parseFailure("Invalid TranslateResult ".concat(e.message));
                }
            }));
        };
        this.http.get("/agencies/".concat(agencyId, "/scu-translations/test?key=").concat(encodeURIComponent(key), "&raw=").concat(encodeURIComponent(raw)), null, this.unauthenticatedCallback(wrappedCallback));
    };
    AgencyMixin.prototype.getPollyTranslation = function (agencyId, text, callback) {
        var _this = this;
        var wrappedCallback = function (req, res) {
            callback(_this.apiResultFromParse(res, function (o) {
                try {
                    var result = {
                        pollyUrl: cerealParse_1.ParseUtils.getString(o, "pollyUrl"),
                        text: cerealParse_1.ParseUtils.getString(o, "text"),
                    };
                    return cerealParse_1.ParseUtils.parseSuccess(result);
                }
                catch (e) {
                    return cerealParse_1.ParseUtils.parseFailure("Invalid PollyResult ".concat(e.message));
                }
            }));
        };
        this.http.get("/agencies/".concat(agencyId, "/scu-translations/polly?text=").concat(encodeURIComponent(text)), null, this.unauthenticatedCallback(wrappedCallback));
    };
    return AgencyMixin;
}());
exports.default = AgencyMixin;
//# sourceMappingURL=AgencyMixin.js.map